import * as React from 'react';

import { CallCentreRegisterThankyouPage } from '../../pages/thankyou/CallCentreRegisterThankyouPage';
import { getWindow } from 'ts/window/Window';
import { getLoginBootstrapUrl } from 'ts/config/ConfigService';
import { USERNAME } from 'ts/constants/UrlParams';
import { Location } from 'history';

interface CallCentreRegisterWizardThankyouPageProps {
  location: Location;
}

const nextAction = (location: Location) => () => {
  const searchParams = new URLSearchParams(location.search);
  const username = searchParams.get(USERNAME);
  return (getWindow().location.href = getLoginBootstrapUrl() + `?${USERNAME}=${username}`);
};

const CallCentreRegisterWizardThankyouPage: React.FC<CallCentreRegisterWizardThankyouPageProps> = ({
  location,
}) => <CallCentreRegisterThankyouPage nextAction={nextAction(location)} />;

export { CallCentreRegisterWizardThankyouPage };
